import { Collapse, Drawer, IconButton, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentRole, getLogo, getOpenSidebar, getServices, getBizID, getStyle, setOpenSidebar } from "../libs/todoSlice"
import fontColor from "../lib/fontColor"
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import SchoolIcon from '@mui/icons-material/School';
import { useNavigate, useParams, Link as RouterLink } from "react-router-dom"
import { useState } from "react"
import CircleIcon from '@mui/icons-material/Circle';
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import axios from "axios"
import { Divider } from "antd"
import { styled, useTheme } from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import { getGroupConfigs } from "../lib/preRegisterConfig"

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const Sidebar = () => {
  const theme = useTheme();
  const dispatch = useDispatch()
  const currentRole = useSelector(getCurrentRole)
  const logo = useSelector(getLogo)
  const style = useSelector(getStyle)
  const bizId = useSelector(getBizID);
  const params = useParams()
  const services = useSelector(getServices)
  const navigate = useNavigate()
  const [openDigitalWorkflow, setOpenDigitalWorkflow] = useState(false);
  const [openPreRegis, setOpenPreRegis] = useState(false)
  const [openBizTab, setOpenBizTab] = useState(false)
  const open = useSelector(getOpenSidebar)
  const setOpen = (action) => {
    dispatch(setOpenSidebar({
      openSidebar: action
    }))
  }

  // ระบบ ThaID มีมากกว่า 1 service ในกลุ่มเดียวกัน (thaid-pre-register, thaid-pre-register-form-general)
  // เช็คว่า business มีสิทธิ์ใช้ตัวใดตัวหนึ่งในกลุ่มนี้หรือไม่ แทน hardcode service เดียว
  // เพิ่มประเภทใหม่ในกลุ่ม 'thaid' ในอนาคต ไม่ต้องแก้ไฟล์นี้เพิ่ม
  const thaidGroupServiceKeys = getGroupConfigs('thaid').map(c => c.serviceKey)
  const hasThaIDAccess = thaidGroupServiceKeys.some(sk => services.includes(sk))

  const ColoredLineSidebar = ({ color }) => (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        width: '120px',
        border: '1px solid ',
        borderColor: color
      }}
    />
  );
  const adminDigitalWorkflow = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/shared-token`,
      })
      if (bizId === "172708638018068") {
        window.open(`https://dwf-pmub.one.th/admin_workflow?token=${data.data.shared_token}`, '_blank');
      } else {
        window.open(`${process.env.REACT_APP_DIGITAL_WORKFLOW}/admin_workflow?token=${data.data.shared_token}`, '_blank');
      }
    } catch ({ response }) {
      const { status } = response
      if (status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }

  const list = [
    {
      show: true,
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/home`}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <HomeIcon style={{ color: fontColor(style.primary_color) }} />
          </ListItemIcon>
          <ListItemText primary="หน้าหลัก" />
        </ListItemButton>
      )
    },
    {
      show: (currentRole === 'RA' || currentRole === 'owner') && (services.includes('manage-business-enrollment')),
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/approve-user`}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <PersonIcon style={{ color: fontColor(style.primary_color) }} />
          </ListItemIcon>
          <ListItemText primary="อนุมัติคนเข้า Business" />
        </ListItemButton>
      )
    },
    {
      show: (currentRole === 'RA' || currentRole === 'owner') &&
        (services.includes('employee-pre-register') || services.includes('employee-pre-register-pmuc')),
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/approve-pre-register`}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <PersonIcon style={{ color: fontColor(style.primary_color) }} />
          </ListItemIcon>
          <ListItemText primary="อนุมัติผู้ลงทะเบียน" />
        </ListItemButton>
      )
    },
    {
      show: currentRole === 'RA' || currentRole === 'owner',
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/manage-members`}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <BarChartRoundedIcon style={{ color: fontColor(style.primary_color) }} />
          </ListItemIcon>
          <ListItemText primary="จัดการพนักงาน" />
        </ListItemButton>
      )
    },
    {
      show: (
        currentRole === 'RA' ||
        currentRole === 'owner'
      ) &&
        (
          services.includes('medical-pre-register') ||
          services.includes('edu-student-pre-register') ||
          services.includes('edu-teacher-pre-register') ||
          services.includes('time-attendance-pre-register') ||
          services.includes('moph-caregiver-pre-register') ||
          services.includes('edu-officer-pre-register') ||
          services.includes('corporation-pre-register') ||
          hasThaIDAccess
        ),
      element: (
        <>
          {(currentRole === 'RA' || currentRole === 'owner') &&
            <ListItemButton
              onClick={() => {
                setOpenPreRegis(!openPreRegis)
              }}>
              <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
                <BarChartRoundedIcon />
              </ListItemIcon>
              <ListItemText primary=" จัดการข้อมูลรอลงทะเบียน" />
              {openPreRegis ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          }
          <Collapse in={openPreRegis} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {((currentRole === 'RA' || currentRole === 'owner') && services.includes('edu-student-pre-register')) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/student`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary='สำหรับนักเรียน/นักศึกษา' />
                </ListItemButton>
              }

              {((currentRole === 'RA' || currentRole === 'owner') && services.includes('edu-teacher-pre-register')) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/teacher`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="สำหรับครู/อาจารย์" />
                </ListItemButton>
              }
              {((currentRole === 'RA' || currentRole === 'owner') && services.includes('medical-pre-register')) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/doctor`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="สำหรับบุคคลากรทางการแพทย์" />
                </ListItemButton>
              }
              {((currentRole === 'RA' || currentRole === 'owner') && services.includes('edu-officer-pre-register')) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/officer`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="สำหรับเจ้าหน้าที่" />
                </ListItemButton>
              }
              {((currentRole === 'RA' || currentRole === 'owner') && services.includes('time-attendance-pre-register')) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/time-attendance`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="ระบบเช็คชื่อนักเรียน" />
                </ListItemButton>
              }
              {((currentRole === 'RA' || currentRole === 'owner') && services.includes('moph-caregiver-pre-register')) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/moph-caregiver`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="ระบบสำหรับผู้ดูแลผู้ป่วย" />
                </ListItemButton>
              }
              {((currentRole === 'RA' || currentRole === 'owner') && services.includes('corporation-pre-register')) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/Corporation`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="ระบบสมาชิก" />
                </ListItemButton>
              }
              {((currentRole === 'RA' || currentRole === 'owner') && services.includes('provider-it-pre-register')) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/provider-id`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="สำหรับบุคลากรทางการแพทย์ (ProviderID)" />
                </ListItemButton>
              }
              {((currentRole === 'RA' || currentRole === 'owner') && hasThaIDAccess) &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/pre-register/thaid`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="ระบบลงทะเบียนด้วย ThaID" />
                </ListItemButton>
              }
            </List>
          </Collapse>
        </>
      )
    },
    {
      show: services.includes('digital-workflow') && process.env.REACT_APP_ENV !== 'production',
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/services/digital-workflow`}
          onClick={() => setOpenDigitalWorkflow(!openDigitalWorkflow)}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <img
              src={`/img/digital-workflow.png`}
              alt="digital-workflow"
              style={{
                width: '30px'
              }}
            />
          </ListItemIcon>
          <ListItemText primary="Digital Workflow" />
        </ListItemButton>
      )
    },
    {
      show: services.includes('digital-workflow') && process.env.REACT_APP_ENV === 'production',
      element: (
        <>
          <ListItemButton
            onClick={() => setOpenDigitalWorkflow(!openDigitalWorkflow)}
          >
            <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
              <img
                src={`/img/digital-workflow.png`}
                alt="digital-workflow"
                style={{
                  width: '30px'
                }}
              />
            </ListItemIcon>
            <ListItemText primary="Digital Workflow" />
            {openDigitalWorkflow ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openDigitalWorkflow} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                component={RouterLink}
                to={`/${params.prefix}/services/digital-workflow`}
              >
                <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                  <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                    <CircleIcon style={{ fontSize: 'small' }} />
                  </ListItemIcon>
                </div>
                <ListItemText primary={(currentRole === 'RA' || currentRole === 'owner') ? "หน้าหลัก" : "กล่องเอกสาร"} />
              </ListItemButton>
              {
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/services/digital-workflow/create`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="สร้างเอกสาร" />
                </ListItemButton>
              }
              {
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/services/digital-workflow/sent_box`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="รายการที่ส่ง" />
                </ListItemButton>
              }
              {(currentRole === 'RA' || currentRole === 'owner') &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/services/digital-workflow/all_document`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="เอกสารทั้งหมด" />
                </ListItemButton>
              }
              {(currentRole === 'RA' || currentRole === 'owner') &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/services/digital-workflow/summary_workflow`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="แดชบอร์ดองค์กร" />
                </ListItemButton>
              }
              {(currentRole === 'RA' || currentRole === 'owner') &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/services/digital-workflow/report`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="รายงานเอกสาร E-Form" />
                </ListItemButton>
              }
              {(currentRole === 'RA' || currentRole === 'owner') &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/services/digital-workflow/summary_workflowv1`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="รายงานการใช้งานเอกสาร" />
                </ListItemButton>
              }
              <ListItemButton
                sx={{ pl: 4 }}
                component={RouterLink}
                to={`/${params.prefix}/services/digital-workflow/setting`}
              >
                <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                  <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                    <CircleIcon style={{ fontSize: 'small' }} />
                  </ListItemIcon>
                </div>
                <ListItemText primary="ตั้งค่าลายเซ็น" />
              </ListItemButton>
              {
                (currentRole === 'RA' || currentRole === 'owner') &&
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => {
                    adminDigitalWorkflow()
                  }}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="สร้างประเภทเอกสาร และ workflow" />
                </ListItemButton>
              }
              <ListItemButton
                sx={{ pl: 4 }}
                component={RouterLink}
                to={`/${params.prefix}/services/digital-workflow/user_guide`}
              >
                <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                  <ListItemIcon style={{ color: fontColor(style.primary_color), display: 'contents' }}>
                    <CircleIcon style={{ fontSize: 'small' }} />
                  </ListItemIcon>
                </div>
                <ListItemText primary="คู่มือการใช้งานระบบ" />
              </ListItemButton>
            </List>
          </Collapse>
        </>
      )
    },

    {
      show: services.includes('edu-portal-management') && (currentRole === 'RA' || currentRole === 'owner'),
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/services/edu-portal-management`}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <SchoolIcon style={{ color: fontColor(style.primary_color) }} />
          </ListItemIcon>
          <ListItemText primary="จัดการหน้าลงทะเบียนคนเข้า Business" />
        </ListItemButton>
      )
    },
    {
      show: services.includes('id-connect') && (currentRole === 'RA' || currentRole === 'owner'),
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/services/id-connect`}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <img
              src={`/img/id-connect.ico`}
              alt="id-connect"
              style={{
                width: '30px'
              }}
            />
          </ListItemIcon>
          <ListItemText primary="ID Connect" />
        </ListItemButton>
      )
    },
    {
      show: services.includes('dipchip-management') && (currentRole === 'RA' || currentRole === 'owner'),
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/services/dipchip-management`}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <img
              src={`/img/dipchip-management.svg`}
              alt="dipchip-management"
              style={{
                width: '50px',
                backgroundColor: '#FFFFFF',
              }}
            />
          </ListItemIcon>
          <ListItemText primary="Dipchip Management" />
        </ListItemButton>
      )
    },
    {
      show: true,
      element: (
        <>
          {
            <ListItemButton
              onClick={() => { setOpenBizTab(!openBizTab) }}
            >
              <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
                <img
                  src={`/img/one-platform-logo.png`}
                  alt="business"
                  style={{
                    width: '40px',
                  }} />
              </ListItemIcon>
              <ListItemText primary="Business" />
              {openBizTab ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          }
          <Collapse in={openBizTab} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                component={RouterLink}
                to={`/${params.prefix}/services/business?type=business_chart`}
              >
                <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                  <ListItemIcon
                    style={{
                      color: fontColor(style.primary_color),
                      display: 'contents',
                    }}
                  >
                    <CircleIcon style={{ fontSize: 'small' }} />
                  </ListItemIcon>
                </div>
                <ListItemText primary="Chart" />
              </ListItemButton>
              {services.includes('business-service') && (
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to={`/${params.prefix}/services/business?type=account`}
                >
                  <div style={{ marginRight: '10px', marginLeft: '40px' }}>
                    <ListItemIcon
                      style={{
                        color: fontColor(style.primary_color),
                        display: 'contents',
                      }}
                    >
                      <CircleIcon style={{ fontSize: 'small' }} />
                    </ListItemIcon>
                  </div>
                  <ListItemText primary="Management" />
                </ListItemButton>
              )}
            </List>
          </Collapse>
        </>
      )
    },
    {
      show: services.includes('e-stamp'),
      element: (
        <ListItemButton
          component={RouterLink}
          to={`/${params.prefix}/services/e-stamp`}
        >
          <ListItemIcon style={{ color: fontColor(style.primary_color) }}>
            <img
              src={`/img/logo_e_stamp.jpg`}
              alt="businesses-chart"
              style={{
                width: '40px',
              }}
            />
          </ListItemIcon>
          <ListItemText primary="E-Stamp" />
        </ListItemButton>
      )
    },
  ].filter(listItem => listItem.show)

  return (
    <Drawer
      sx={{
        width: 260,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 260,
          boxSizing: 'border-box',
          background: style.primary_color ?? '#053075',
          color: fontColor(style.primary_color)
        },
      }}
      variant="persistent"
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      anchor="left"
      open={open}
    >
      <DrawerHeader>
        <IconButton
          onClick={() => {
            setOpen(false);
          }}
          style={{
            color: fontColor(style.primary_color)
          }}
        >
          {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </DrawerHeader>
      <div style={{ textAlign: 'center', margin: '30px 30px 0 30px' }}>
        <img
          src={logo ? `data:image/png;base64, ${logo}` : "/logo.png"}
          onError={(e) => {
            e.target.src = '/one-platform.png'
          }}

          alt=""
          style={{
            maxWidth: style.logo_style == 2 ? '140px' : '80px',
            width: '100%',
            height: '100%',
            maxHeight: '80px',
            boxShadow: '2px 2px 6px',
            borderRadius: '5px'
          }}
        />
        <div style={{ color: fontColor(style.primary_color), marginTop: '10px' }}>
          <span>{params.prefix.toUpperCase()}</span>
        </div>
      </div>
      <div style={{ textAlign: '-webkit-center', }}>
        <ColoredLineSidebar color={fontColor(style.primary_color)} />
      </div>
      <List className="scroll-container" style={{ color: fontColor(style.primary_color) }}>
        {list.map((listItem, key) => {
          return (
            <div key={key}>{listItem.element}</div>
          )
        })}
      </List>
      <Divider />
    </Drawer>
  )
}

export default Sidebar